// component
import { Button } from "react-bootstrap";
// icons & images
import { FaMapMarkerAlt } from "react-icons/fa";
import logoBorder from "../../assets/images/logo-border.svg";
import logo from "../../assets/images/logo/main-logo-removebg.png";
import { FaPhone } from "react-icons/fa";

// style
import "./index.scss";
import { NavLink } from "react-router-dom";
export default function AboutYung({ showTells = false }) {
  return (
    <div>
      <div className="about-yung pd-y-40 pd-x-48 d-flex justify-content-between">
        <div className="text-container mr-t-70">
          <h4 className="font-32-700">یانگ گالری</h4>

          <p className="font-18-500 pd-y-10">
            یانگ گالری فروشگاه تخصصی به روز ترین اکسسوری بدلیجات و ساعت برای
            تمام سنین و سلیقه ها با محصولات با کیفیت و تماما وارداتی در خدمت شما
            عزیزان هستیم از سال ۱۳۹۹ هم به صورت حضوری هم آنلاین با هدف خاص و شیک
            تر شدن استایل شما{" "}
          </p>

          {showTells && (
            <>
              <div className="w-100 ">
                <a
                  href="tel:۰۹۳۷۸۵۹۲۴۲۰"
                  className=" font-18-500 text-decoration-none text-dark "
                >
                  <FaPhone className="mx-2" style={{ width: 20, height: 20 }} />
                  ۰۹۳۷۸۵۹۲۴۲۰
                </a>
              </div>
              <div className="w-100 ">
                <a
                  href="tel:۰۹۹۰۹۳۸۱۱۹۵"
                  className=" font-18-500 mt-2 text-decoration-none text-dark"
                >
                  <FaPhone className="mx-2" style={{ width: 20, height: 20 }} />
                  ۰۹۹۰۹۳۸۱۱۹۵
                </a>
              </div>
            </>
          )}
          <NavLink
            to={"https://www.google.com/maps?q=36.826254,%2054.446741"}
            target="_blank"
            className="mr-y-24 pd-y-12 pd-x-18 rd-100 d-flex align-items-center btn-style-for-link text-decoration-none text-light"
            onClick={() => {
              // window.location.href = "https://maps.app.goo.gl/Pf6F4kzWM4ToDiNY9";
            }}
          >
            <FaMapMarkerAlt style={{ width: 18, height: 18 }} />
            <span className="mr-r-4 font-16-700">آدرس ما در نقشه</span>
          </NavLink>
        </div>
        <div className="logo-container pd-x-16 pd-y-24">
          <div className=" image-overlay-container">
            <img className="background-image" src={logoBorder} />
            <img className="overlay-image" src={logo} />
          </div>
        </div>
      </div>
    </div>
  );
}
